import { useState } from "react";
import { Box } from "@mui/material";

import { CarrierDetailPanel } from "./CarrierDetailPanel";
import { CarrierListPanel } from "./CarrierListPanel";

import type { Carrier } from "../types";

export const DirectoryTab = (): React.JSX.Element => {
  const [selectedCarrier, setSelectedCarrier] = useState<Carrier | null>(null);

  return (
    <Box display="flex" gap={2} height="100%">
      <Box width="25%" flexShrink={0}>
        <CarrierListPanel
          selectedCarrier={selectedCarrier}
          onSelectCarrier={setSelectedCarrier}
        />
      </Box>
      <Box flex={1}>
        <CarrierDetailPanel carrier={selectedCarrier} />
      </Box>
    </Box>
  );
};
